import React from 'react';
import { Intros, ServiceCarousel} from '../../components';
import { APIsList } from '../../list'
import './main-view.css';

let intros = [
    {
        title: 'نمایش راهکارهای مپ',
        description: 'استفاده از راهکارهای مکان محور می‌تواند برگ برنده هر کسب و کاری باشد. ما در اینجا مجموعه‌ای از راهکارهای پیاده‌سازی شده با استفاده از زیرساخت نقشه مپ را به صورت دمو فراهم کرده‌ایم. این راهکارها به تفکیک سرویس‌های مپ و نوع کسب و کار در اختیار شما قرار می‌گیرد تا دید بهتری نسب به کاربردها و مزیت‌های سرویس نقشه مپ داشته باشید.',
        buttonText: 'نمایش راهکارها',
        image: 'intro1'
    },
    {
        title: 'اهمیت راهکارهای مپ',
        description: 'اهمیت استفاده از داده‌های مکان محور و کاربردهای آن بر کسی پوشیده نیست اما در بسیاری موارد پیاده‌سازی این راهکارها با چالش‌هایی رو به رو خواهد بود. برخی از این چالش‌ها به چگونگی استفاده از داده‌های مکانی و برخی دیگر به نحوه پیاده‌سازی پروژه مرتبط است. نسخه نمایشی راهکارهای مپ به شما کمک می‌کند تا ضمن مشاهده نحوه بکارگیری این سرویس‌ها، ساختار پیاده‌سازی بهینه‌شده‌ای را برای استفاده در پروژه خود داشته باشید.',
        buttonText: 'نمایش راهکارها',
        image: 'intro2'
    }
]

function MainView(){
    return (
        <main>
            <Intros list={intros} />
            <ServiceCarousel list={APIsList} />
        </main>
    )
}

export default MainView;